"use strict";

module.exports = {
	VBUTTON_SERVICE: "fffffff0-00f7-4000-b000-000000000000",

	STEALTH_MODE: "fffffff1-00f7-4000-b000-000000000000",
	STEALTH_MODE_NORMAL: data([0x00]),
	STEALTH_MODE_QUIET: data([0x01]),
	STEALTH_MODE_NOBLINK: data([0x02]),
	STEALTH_MODE_STEALTH: data([0x03]),

	URGENT_ALERT: "fffffff3-00f7-4000-b000-000000000000",
	URGENT_ALERT_ON: data([0x01]),
	URGENT_ALERT_OFF: data([0x00]),

	DETECTION_NOTIFICATION: "fffffff4-00f7-4000-b000-000000000000",
	DETECTION_MODE_CONFIG: "fffffff2-00f7-4000-b000-000000000000",
	DETECTION_MODE_NONE: data([0x00]),
	DETECTION_MODE_PRESS: data([0x01]),
	DETECTION_MODE_HOLD: data([0x02]),
	DETECTION_MODE_FALL: data([0x04]),
	DETECTION_MODE_PRESS_FALL: data([0x05]),
	DETECTION_MODE_INACTIVITY: data([0x11]),

	VERIFICATION: "fffffff5-00f7-4000-b000-000000000000",
	VERIFICATION_KEY: data([0x80, 0xBE, 0xF5, 0xAC, 0xFF]),

	BATTERY_SERVICE: "180F",
	BATTERY_LEVEL: "2a19",

	ACCELEROMETER_SERVICE: "ffffffa0-00f7-4000-b000-000000000000",
	ACCELEROMETER_X: "ffffffa3-00f7-4000-b000-000000000000",
	ACCELEROMETER_Y: "ffffffa4-00f7-4000-b000-000000000000",
	ACCELEROMETER_Z: "ffffffa5-00f7-4000-b000-000000000000",

	METAWEAR_DEVICE_INFO_SERVICE: "0000180a-0000-1000-8000-00805f9b34fb",
	METAWEAR_DEVICE_INFO_CHARACTERISTIC: "00002a26-0000-1000-8000-00805f9b34fb",

	DEVICE_BATTERY_SERVICE: "0000180f-0000-1000-8000-00805f9b34fb",
	DEVICE_BATTERY_CHARACTERISTIC: "00002a19-0000-1000-8000-00805f9b34fb",

	METAWEAR_SERVICE: "326a9000-85cb-9195-d9dd-464cfbbae75a",
	METAWEAR_READ_CHARACTERISTIC: "326a9006-85cb-9195-d9dd-464cfbbae75a",
	METAWEAR_WRITE_CHARACTERISTIC: "326a9001-85cb-9195-d9dd-464cfbbae75a",

	NONIN_READ_CHARACTERISTIC:"0AAD7EA0-0D60-11E2-8E3C-0002A5D5C51B",
	NONIN_SERVICE: "46A970E0-0D5F-11E2-8B5E-0002A5D5C51B",
	NONIN_CONTROL_CHARACTERISTIC: "1447AF80-0D60-11E2-88B6-0002A5D5C51B",
	NONIN_3230_DONE_READING: data([0x62, 0x4E, 0x4D, 0x49]),

	ANDBP_SERVICE: "00001810-0000-1000-8000-00805f9b34fb",
	ANDBP_READ_CHARACTERISTIC: "00002a35-0000-1000-8000-00805f9b34fb",
	
	BIOSBP_SERVICE: "0000fff0-0000-1000-8000-00805f9b34fb",
	BIOSBP_READ_CHARACTERISTIC: "0000fff1-0000-1000-8000-00805f9b34fb",
	
	IHBP_SERVICE: "00001810-0000-1000-8000-00805f9b34fb",
	IHBP_READ_CHARACTERISTIC: "00002a35-0000-1000-8000-00805f9b34fb",
	IHBP_FEATURE_CHARACTERISTIC: "00002a49-0000-1000-8000-00805f9b34fb",
	
	IHWEIGHT_SERVICE: "0000181d-0000-1000-8000-00805f9b34fb",
	IHWEIGHT_READ_CHARACTERISTIC: "00002a9d-0000-1000-8000-00805f9b34fb",
	IHWEIGHT_FEATURE_CHARACTERISTIC: "00002a9e-0000-1000-8000-00805f9b34fb",

	IHO2_SERVICE: "00001822-0000-1000-8000-00805f9b34fb",
	IHO2_ACCESS_POINT: "00002a52-0000-1000-8000-00805f9b34fb",
	IHO2_SPOT_CHECK: "00002a5e-0000-1000-8000-00805f9b34fb",
	IHO2_REAL_TIME_CHECK: "00002a5f-0000-1000-8000-00805f9b34fb",
	IHO2_GET_READINGS: data([0x01, 0x01]),
	IHO2_DELETE_READINGS: data([0x02, 0x01]),

	ANDWEIGHT_SERVICE: "23434100-1FE4-1EFF-80CB-00FF78297D8B",
	ANDWEIGHT_READ_CHARACTERISTIC: "23434101-1FE4-1EFF-80CB-00FF78297D8B",
	
	ANDWEIGHT_SERVICE_EU: "0000181d-0000-1000-8000-00805f9b34fb",
	ANDWEIGHT_READ_CHARACTERISTIC_EU: "00002a9d-0000-1000-8000-00805f9b34fb",

	FORA_TNG_SERVICE: "00001523-1212-EFDE-1523-785FEABCD123",
	FORA_TNG_READWRITE_CHARACTERISTIC: "00001524-1212-EFDE-1523-785FEABCD123",
	FORA_TNG_TIME: data([0x51, 0x25, 0x00, 0x00, 0x00, 0x00, 0xA3, 0X19]),
	FORA_TNG_READING: data([0x51, 0x26, 0x00, 0x00, 0x00, 0x00, 0xA3, 0X1A]),
	FORA_TNG_STORE_NUMBER: data([0x51, 0x2B, 0x00, 0x00, 0x00, 0x00, 0xA3, 0X1F]),
	FORA_TNG_RESET: data([0x51, 0x52, 0x00, 0x00, 0x00, 0x00, 0xA3, 0X46]),
	FORA_TNG_RECORD_ACCESS_CONTROL_POINT: "00002A52-0000-1000-8000-00805f9b34fb",
	
	FORA_TNG_MONITOR_SPO_START: data([0x51, 0x47, 0x02, 0x00, 0x00, 0x00, 0xA3, 0x3D]),
	FORA_TNG_MONITOR_SPO_STOP: data([0x51, 0x47, 0x00, 0x00, 0x00, 0x00, 0xA3, 0x3B]),
	
	FORA_TNG_POWER_OFF: data([0x51, 0x50, 0x00, 0x00, 0x00, 0x00, 0xA3, 0x44]),

	GATT_CURRENT_TIME_SERVICE: "00001805-0000-1000-8000-00805f9b34fb",
	GATT_CURRENT_TIME_CHARACTERISTIC: "00002a2b-0000-1000-8000-00805f9b34fb",

	METAWEAR_INITIALIZE: data([0x0B, 0x84]),

	METAWEAR_ACCELEROMETER_CONFIGURE: data([0x03, 0x18, 0x1D, 0x0F]),
	METAWEAR_ACCELEROMETER_STOP: data([0x03, 0x01, 0x00]),
	METAWEAR_ACCELEROMETER_START: data([0x03, 0x01, 0x01]),
	METAWEAR_ACCELEROMETER_STEP_READ: data([0x03, 0x9A]),
	METAWEAR_ACCELEROMETER_STEP_RESET: data([0x03, 0x1B]),

	METAWEAR_LED_STOP: data([0x02, 0x02, 0x00]),
	METAWEAR_LED_CLEAR: data([0x02, 0x02, 0x01]),
	METAWEAR_LED_AUTOPLAY: data([0x02, 0x01, 0x02]),
	METAWEAR_LED_PLAY: data([0x02, 0x01, 0x01]),
	METAWEAR_LED_CONFIGURE: data([0x02, 0x03, 0x00, 0x02, 0x1f, 0x00, 0xd5, 0x02, 0xf4, 0x01, 0xd5, 0x02, 0xd0, 0x07, 0x00, 0x00, 0x03])
};

function data(bytes) {
	return (new Uint8Array(bytes)).buffer;
}
